import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { SignedIn, SignedOut, useAuth } from '@clerk/clerk-react';

import { ClerkTokenSingleton } from '~/services/token';
import { login as clientLogin } from '~/services/clientApi';
import { login as loginAction } from '~/store/auth';

function InitToken() {
  const { isSignedIn, getToken } = useAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    let cancelled = false;

    async function init() {
      try {
        if (!isSignedIn) return;

        const token = await getToken();

        if (cancelled || !token) return;

        try {
          await ClerkTokenSingleton.I.init(null, token);
        } catch (e) {
          // ignore re-init attempts
        }

        try {
          const user = await clientLogin(token);
          if (user) {
            dispatch(loginAction(user));
          }
        } catch (e) {
          console.error('Failed to fetch user from client API', e);
        }
      } catch (e) {
        console.error('Failed to init Clerk token', e);
      }
    }

    init();

    return () => {
      cancelled = true;
    };
  }, [isSignedIn, getToken, dispatch]);

  return null;
}

export default function AuthGateInner({ children }) {
  const { isLoaded, isSignedIn } = useAuth();
  const isLoggedIn = useSelector(state => state.auth.isLoggedIn);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // If signed out and not already on /login, redirect to /login
    if (isLoaded && !isSignedIn) {
      const path = location?.pathname || '';
      if (!path.startsWith('/login')) {
        navigate('/login', { replace: true });
      }
    }
  }, [isLoaded, isSignedIn, location?.pathname, navigate]);

  if (!isLoaded) {
    return null;
  }

  return (
    <>
      <InitToken />
      <SignedIn>{isLoggedIn ? children : null}</SignedIn>
      <SignedOut>
        {/*   /!* <ClerkAuth /> // custom login form *!/ */}
        {location?.pathname?.startsWith('/login') && children} // default login
        for provided by Clerk
      </SignedOut>
    </>
  );
}

AuthGateInner.propTypes = {
  children: PropTypes.node,
};
AuthGateInner.defaultProps = {
  children: null,
};
